import type { AxiosInstance, AxiosResponse } from 'axios';

import type { RootResponse } from '@/models/rootResponse';
import type { SurveyType } from '@/models/surveyType';

class SurveyTypeService {
   private provider: AxiosInstance;

   constructor(provider: AxiosInstance) {
      this.provider = provider;
   }

   async getSurveyTypes(): Promise<RootResponse<SurveyType[]>> {
      const response: AxiosResponse<RootResponse<SurveyType[]>> =
         await this.provider.post('/rest/survey-types/search');
      return response.data;
   }
}

export default SurveyTypeService;
